import { render } from "./testmethoddetailview.vue?vue&type=template&id=3d5328ff"
import script from "./testmethoddetailview.vue?vue&type=script&lang=js"
export * from "./testmethoddetailview.vue?vue&type=script&lang=js"

import "./testmethoddetailview.vue?vue&type=style&index=0&id=3d5328ff&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__